import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { errorModalTextRecoil, completeModalRecoil } from '@/atom/ModalAtom';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Router from '@/router/Router';
import ErrorModal from '@/modal/ErrorModal';
import CompleteModal from '@/modal/CompleteModal';
import useKakaoLoader from './utils/useKakaoLoader';

function App() {
  const [loading] = useKakaoLoader();

  const errorModalText = useRecoilValue(errorModalTextRecoil);
  const completeModalState = useRecoilValue(completeModalRecoil);

  return (
    <>
      {loading === false ? <Router /> : null}
      {errorModalText !== '' && <ErrorModal />}
      {completeModalState && <CompleteModal />}
    </>
  );
}

export default App;
